export default __webpack_public_path__ + "locales/fr/Webhooks.json?hash=8e456b3821312ae385e6d69916053c23";